module.exports = __webpack_public_path__ + "img/hangye.996d9079.png";